// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/funnel.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/funnel'

import { Icon, type IconComponentProps } from '../icon'

export const FunnelIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
